import script from "./FocusController.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocusController.vue?vue&type=script&setup=true&lang=ts"

import "./FocusController.vue?vue&type=style&index=0&id=77862bc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77862bc2"]])

export default __exports__